/** "Hozir qo'ng'iroq qilsa bo'ladi": backend nomzodlaridan (tartibi: eslatmasi kelganlar, keyin eng uzoq gaplashilmaganlar)
 * mahalliy vaqti qo'ng'iroq oynasida bo'lganlarini tanlash (test: pick.test.ts). Zona -- shtatdan (features/drivers/timezones). */
import { callWindow, driverTz } from "@/features/drivers/timezones";

export interface CallCandidate {
  driver_id: number;
  name: string;
  state: string;
  status: string;
  status_label: string;
  reminder_due: boolean;
  last_contact_at: string | null;
}

export interface Callable extends CallCandidate {
  tz: string;
  /** Oyna yopilishiga necha daqiqa qoldi */
  minutes: number;
}

export function pickCallable(rows: CallCandidate[], now: Date, call: readonly [number, number]): Callable[] {
  const out: Callable[] = [];
  for (const r of rows) {
    const tz = driverTz(r.state);
    const w = callWindow(now, tz, call);
    if (w.open) out.push({ ...r, tz, minutes: w.minutes });
  }
  return out;
}

/** Hozir oynasi ochiq shtatlardagi driverlar soni -- hamma driver bo'yicha (backend `states`: shtat -> son), ro'yxat kesilgan bo'lsa ham aniq */
export function countCallable(states: Record<string, number>, now: Date, call: readonly [number, number]): number {
  let n = 0;
  for (const [state, count] of Object.entries(states)) if (callWindow(now, driverTz(state), call).open) n += count;
  return n;
}

/** Oxirgi aloqadan beri necha kun (null -- hech qachon) */
export function daysSince(iso: string | null, now: Date): number | null {
  if (!iso) return null;
  const ms = now.getTime() - new Date(iso).getTime();
  return Math.max(0, Math.floor(ms / 86_400_000));
}
